import * as AF from "@/components/form-items/AbstractForm";
import { SupportedLocale } from "@/i18n";
import { useTranslation } from "react-i18next";

export const SelectionForm = ({ lang }: { lang: SupportedLocale }) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${lang}.pageName`}
        label={t("cms.selection.form.pageName")}
      />
      <AF.RichText
        name={`${lang}.content`}
        label={t("cms.selection.form.content")}
      />
    </AF.Col>
  );
};
